/**
 * Created by zoechodosh on 3/8/17.
 */
import fetch from 'isomorphic-fetch';
import { toastsActions } from '@zola-helpers/client';

import * as ActionTypes from '../types/website/FileUploadActionTypes';
import * as ModalActionTypes from '../types/ModalActionTypes';
import * as GuestActions from '../GuestActions';
import * as ModalActions from '../ModalActions';
import {
  isFileEmpty,
  isMaxFileSize,
  emptyFileMessage,
  maxFileMessage,
} from './FileUploadActionsUtil';

// TODO: move this file to '/src/actions/'

// TODO: MOVE THIS AND USE FOR ALL REQUESTS!!!!
// -> use 'src/api.js: handleErrors'
function handleErrors(response) {
  if (!response.ok) {
    const error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
  return response;
}

function handleToastError(headline) {
  return dispatch => dispatch(toastsActions.negative({ headline }));
}

export function uploading(imgKey) {
  return {
    type: ActionTypes.FILE_UPLOADING,
    payload: imgKey,
  };
}

export function uploaded(data, imgKey) {
  const fileData = {};
  fileData[imgKey] = data;
  fileData[imgKey].busy = false;
  return {
    type: ActionTypes.FILE_UPLOADED,
    payload: fileData,
  };
}

export function tempUploaded(data, imgKey) {
  const fileData = {};
  fileData[imgKey] = data;
  fileData[imgKey].busy = false;
  return {
    type: ActionTypes.FILE_TEMP_UPLOADED,
    payload: fileData,
  };
}

export function fileCropped(data, imgKey) {
  const fileData = {};
  fileData[imgKey] = data;
  fileData[imgKey].busy = false;
  return {
    type: ActionTypes.FILE_CROPPED,
    payload: fileData,
  };
}

// stores s3 reference key to hold for user confirmation
export function storeReferenceToken(referenceToken) {
  return {
    type: ActionTypes.STORE_REFERENCE_KEY,
    payload: referenceToken,
  };
}

// empties stored s3 reference key
export function resetReferenceToken() {
  return {
    type: ActionTypes.STORE_REFERENCE_KEY,
    payload: '',
  };
}

// todo: actually figure out how to render submit buttons so this isn't necessary.
export function disableUploadButton() {
  return {
    type: ModalActionTypes.IS_BUSY,
    payload: true,
  };
}

// empties states in cases of invalid false-state submit
export function handleFailedSubmit(referenceKey) {
  return dispatch => {
    dispatch({
      type: ActionTypes.STORE_REFERENCE_KEY,
      payload: referenceKey,
    });
    dispatch({
      type: ModalActionTypes.IS_BUSY,
      payload: false,
    });
  };
}

export function uploadPhoto(file, imgKey) {
  return dispatch => {
    const fileSize = file.files[0].size;

    if (isFileEmpty(fileSize)) {
      return dispatch(handleToastError(emptyFileMessage));
    }
    if (isMaxFileSize(fileSize)) {
      return dispatch(handleToastError(maxFileMessage));
    }

    dispatch(uploading(imgKey));
    const formData = new FormData();
    formData.append('attachment', file.files[0], file.name);

    return fetch('/web-api/v1/image/upload', {
      credentials: 'same-origin',
      method: 'POST',
      body: formData,
    })
      .then(response => response.json())
      .then(json => dispatch(uploaded(json, imgKey)))
      .catch(() => {});
  };
}

export function tempUpload(file, imgKey) {
  return dispatch => {
    const fileSize = file.files[0].size;

    if (isFileEmpty(fileSize)) {
      return dispatch(handleToastError(emptyFileMessage));
    }
    if (isMaxFileSize(fileSize)) {
      return dispatch(handleToastError(maxFileMessage));
    }

    dispatch(uploading(imgKey));

    const formData = new FormData();
    formData.append('attachment', file.files[0], file.name);
    return fetch('/web-api/v1/image/temp-upload', {
      credentials: 'same-origin',
      method: 'POST',
      body: formData,
    })
      .then(response => response.json())
      .then(json => dispatch(tempUploaded(json, imgKey)))
      .catch(() => {});
  };
}

const checkImage = path =>
  new Promise(resolve => {
    const img = new Image();
    img.onload = () => resolve({ path, status: 'ok', width: img.width, height: img.height });
    img.onerror = () => resolve({ path, status: 'error' });
    img.src = path;
  });

export function tempUploadPromise(file, imgKey) {
  return dispatch => {
    const fileSize = file.files[0].size;

    if (isFileEmpty(fileSize)) {
      return dispatch(handleToastError(emptyFileMessage));
    }
    if (isMaxFileSize(fileSize)) {
      return dispatch(handleToastError(maxFileMessage));
    }

    dispatch(uploading(imgKey));
    const formData = new FormData();
    formData.append('attachment', file.files[0], file.name);
    const URL = window.URL || window.webkitURL;
    const path = URL.createObjectURL(file.files[0]);
    return checkImage(path).then(img => {
      const imgSize = Math.max(img.width, img.height);
      formData.append('size', imgSize);
      return fetch('/web-api/v1/image/temp-upload', {
        credentials: 'same-origin',
        method: 'POST',
        body: formData,
      })
        .then(response => response.json())
        .then(json => dispatch(tempUploaded(json, imgKey)));
    });
  };
}

export function saveCrop(bucketName, s3key, crop, contentType, imgKey) {
  return dispatch => {
    dispatch(uploading(imgKey));
    const requestBody = JSON.stringify({ bucketName, s3key, crop, contentType });
    return fetch('/web-api/v1/image/crop-save', {
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
      },
      body: requestBody,
    })
      .then(response => response.json())
      .then(json => dispatch(fileCropped(json.data, imgKey)));
  };
}

// final submit after user confirmation in cases of 'false' import check
export function submitUserConfirmation() {
  return (dispatch, getState) => {
    const storedKey = getState().website.entities.referenceKey;
    const token = JSON.stringify({ token: storedKey });
    dispatch(disableUploadButton());
    return fetch('/web-api/v1/guestgroup/import/csv', {
      credentials: 'same-origin',
      headers: {
        'Content-type': 'application/json',
      },
      method: 'POST',
      body: token,
    })
      .then(handleErrors)
      .then(() => dispatch(resetReferenceToken()))
      .then(() => dispatch(GuestActions.fetchGuestList()))
      .then(() => dispatch(toastsActions.positive({ headline: 'Guests Added' })))
      .then(() => dispatch(ModalActions.hideModal()));
  };
}

// old CSV upload:
// TODO: investigate why this endpoint is still being accesed
function handleTypeResponse(response, guestsInGuestList) {
  const referenceToken = response.token;
  if (response.isValid === false && guestsInGuestList.length > 0) {
    return dispatch => {
      dispatch(storeReferenceToken(referenceToken));
      dispatch(ModalActions.showModal('CHECK_GUEST_DUPLICATES', {}, { size: 'md' }));
    };
  }
  if (response.isValid === true || (response.isValid === false && guestsInGuestList.length === 0)) {
    return dispatch => {
      const token = JSON.stringify({ token: response.token });
      return fetch('/web-api/v1/guestgroup/import/csv', {
        credentials: 'same-origin',
        headers: {
          'Content-type': 'application/json',
        },
        method: 'POST',
        body: token,
      })
        .then(handleErrors)
        .then(() => dispatch(toastsActions.positive({ headline: 'Guests Added' })))
        .then(() => dispatch(ModalActions.hideModal()));
    };
  }
  return response;
}

// checks file upload import type
export function checkCsv(file, guestsInGuestList) {
  return dispatch => {
    const formData = new FormData();
    formData.append('attachment', file.files[0], file.name);

    return fetch('/web-api/v1/guestgroup/import/check', {
      credentials: 'same-origin',
      method: 'POST',
      body: formData,
    })
      .then(handleErrors)
      .then(response => response.json())
      .then(json => dispatch(handleTypeResponse(json, guestsInGuestList)));
  };
}



// WEBPACK FOOTER //
// ./src/actions/website/FileUploadActions.js